import React from "react";
import { Loader2 } from "lucide-react";

/**
 * Three intents only.
 *   primary   — the one action the screen exists for (ink, or seal on dark)
 *   secondary — supporting actions that sit next to it
 *   ghost     — table and toolbar chrome
 */
const VARIANTS = {
  primary:
    "bg-[#8f5eeb] text-white hover:bg-ink-800 active:bg-ink-950 disabled:bg-ink-300 shadow-raised",
  seal: "bg-[linear-gradient(135deg,#8f5eeb,#7a54e5)] text-white hover:bg-[#8f5eeb]-400 active:bg-[#8f5eeb]-600 disabled:bg-[#8f5eeb]-100 disabled:text-ink-400 shadow-raised",
  secondary:
    "bg-white text-ink-800 border border-ink-200 hover:border-ink-300 hover:bg-ink-100/60 disabled:text-ink-300",
  ghost:
    "text-ink-600 hover:bg-ink-100 hover:text-ink-900 disabled:text-ink-300",
  danger:
    "bg-white text-opposed border border-opposed/25 hover:bg-opposed-soft",
};

const SIZES = {
  sm: "h-8 px-3 text-xs gap-1.5",
  md: "h-10 px-4 text-sm gap-2",
  lg: "h-12 px-6 text-[15px] gap-2",
};

export default function Button({
  variant = "primary",
  size = "md",
  loading = false,
  icon: Icon,
  children,
  className = "",
  disabled,
  ...props
}) {
  return (
    <button
      type="button"
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center rounded font-semibold transition-colors
        disabled:cursor-not-allowed ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...props}
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
      ) : (
        Icon && (
          <Icon
            className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"}
            aria-hidden="true"
          />
        )
      )}
      {children}
    </button>
  );
}
